import { Component } from "@angular/core";
import { NavController, NavParams } from "ionic-angular";
import { Member } from "../../models/interfaces/member.model";
import { ConfigService } from "../../providers/dbservice/configservice";
import { DbserviceProvider } from "../../providers/dbservice/dbservice";

@Component({
  selector: "page-onhome",
  templateUrl: "onhome.html",
})
export class OnhomePage {
  private member = [];
  private st_id: number;
  private styleName: string ="";

  constructor(public navCtrl: NavController, private db: DbserviceProvider, public navParams: NavParams, private configService: ConfigService) {
    console.log("OnHomePage constructor");
    this.styleName=this.configService.getConfig("STYLENAME");
    this.st_id = 6;
  }

  private ionViewWillEnter() {
    console.log("OnHomePage ionViewWillEnter");
    this.onInitPage();
  }

  private onInitPage() {
    console.log("OnHomePage onInitPage");
    let mbrDefaultOrder = this.configService.getConfig("DEFAULT_MEMBER_DISPLAY_ORDER");

    this.db.dbCol({
      "action": "select", "mapObject": "member",
      "sqlExtended": " where member.st_id=" + this.st_id + " order by mb_resignationdate desc, " + mbrDefaultOrder,
    }).subscribe((mbr) => {
      this.member = mbr;
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/onhome/onhome.ts